import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-LoginNewFlow" */'shared-components/components/LoginNewFlow'));
